// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FcSUH","controls":"styles_controls__3IIBT","charLimit":"styles_charLimit__2F-IM","input":"styles_input__16aoU","send":"styles_send__1YPO_"};